import { Box, Button, TextField } from "@mui/material";
import { useAuth } from "models/AuthModel";

const Login = () => {
  const { signIn } = useAuth();
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    (async () => {
      await signIn(data.get("email"), data.get("password"));
    })();
  };

  return (
    <>
      {/* <img src="/static/brand-logo.jpg" alt="日清医療食品株式会社" style={{ maxWidth: "70%", marginRight: "auto" }} /> */}
      <div style={{ width: "100%" }}>
        <img src="/static/cockpit_logo.png" alt="COCKPIT" style={{ maxWidth: "100%", maxHeight: "100%" }} />
      </div>
      {/* <Typography component="h1" variant="h5" sx={{ mt: 5, mb: 1 }}>
        COCKPIT System
      </Typography> */}
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label="User Name"
          name="email"
          autoComplete="email"
          autoFocus
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        {/* <FormControlLabel control={<Checkbox value="remember" color="primary" />} label="Remember me" /> */}
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
          Sign In
        </Button>
        {/* <Grid container>
          <Grid item xs>
            <Link href="#" variant="body2">
              Forgot password?
            </Link>
          </Grid>
          <Grid item>
            <Link href="#" variant="body2">
              {"Don't have an account? Sign Up"}
            </Link>
          </Grid>
        </Grid> */}
      </Box>
    </>
  );
};

export default Login;
